var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-territory-checkups-routes__cell"},[_vm._v(" "+_vm._s(_vm.startDate)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }